<div class="tags-container d-flex">
    <div class="element-tag" *ngFor="let tag of tags">
        {{tag}}
    </div>
</div>